export default {
  compare(tableList, tableSelectionList, cacheList) {
    // 同步已选列表
    const newArr = [...cacheList];

    // 添加在当前分页下，不在已选列表中的数据
    tableSelectionList.forEach(item => {
      if (!cacheList.some(k => k.guid === item.guid)) {
        newArr.push(item);
      }
    });

    // 移除在已选列表，不在当前分页下的数据
    const tableUnSelection = tableList.filter(item => tableSelectionList.every(k => k.guid !== item.guid));

    return newArr.filter(item => tableUnSelection.every(k => k.guid !== item.guid));
  },
};
